var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"brelag-led",style:({
            'background-color': _vm.color,
            'box-shadow': _vm.shadow
        })})])
}
var staticRenderFns = []

export { render, staticRenderFns }